import { render, staticRenderFns } from "./radar-chart-widget.vue?vue&type=template&id=940c1424"
import script from "./radar-chart-widget.vue?vue&type=script&lang=js"
export * from "./radar-chart-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('940c1424')) {
      api.createRecord('940c1424', component.options)
    } else {
      api.reload('940c1424', component.options)
    }
    module.hot.accept("./radar-chart-widget.vue?vue&type=template&id=940c1424", function () {
      api.rerender('940c1424', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/chart-widget/radar-chart-widget.vue"
export default component.exports